import React, { useEffect } from "react";
import Nav from "./Nav";
import Price from "./Price";
import Footer from "./Footer";
import DatePicker from "./DatePicker";
import { Link } from "react-router-dom";
import TextCarasoulForPricing from "./TextCarasoulForPricing";
import FAQs from "./FAQs";
import AOS from "aos";
import "aos/dist/aos.css";
import PriceYoutube from "./PriceYoutube";

const Pricing = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>
      <Nav active="pricing" />
      {/* <Price /> */}
      <PriceYoutube />
      <div className="bg-white border-8 border-red-600 pb-28">
        <div data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
          <div className="pt-28 pb-10 max-w-[1320px] mx-auto px-5">
            <h1 className="md:text-[43px] text-[30px] text-center lg:text-left  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
              "Director chair" add-ons
            </h1>
            <h1 className=" text-[25px] opacity-80 text-center lg:text-left  mb-8 leading-[40px] max-w-[1000px] text-[#1b0c3e] mt-3">
              Customize your videos even more, if and when you need it. Add
              these extras onto your purchase after you've picked either a
              monthly or quarterly retainer.
            </h1>
          </div>
          <div className=" max-w-[1320px] mx-auto flex flex-wrap xl:justify-between justify-around">
            <div className="border m-2 my-4 md:min-w-[420px] md:max-w-[420px] p-8 bg-white  flex-wrap justify-evenly  items-center">
              <img
                src={require("../images/customThumnail.png")}
                alt=""
                className="mx-auto h-44 w-44"
              />
              <div className="max-w-[410px]">
                <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3">
                  {`Custom thumbnails`}
                </h1>
                <p className="w-4 my-3 border-2"></p>
                <p className=" text-[18px] text-[#4f4f4f] text-center sm:text-left mt-4 sm:mt-2">
                  {`Get more views with personalized thumbnails for all your videos. See examples from our video podcast,`}{" "}
                  <span className="font-semibold text-[#1b0c3e]">
                    {" "}
                    The Videocraft Show.{" "}
                  </span>
                </p>
              </div>
            </div>
            <div className="border m-2 my-4 md:min-w-[420px] md:max-w-[420px] p-8 bg-white  flex-wrap justify-evenly  items-center">
              <img
                src={require("../images/spellchecked.png")}
                alt=""
                className="mx-auto h-44 w-44"
              />
              <div className="max-w-[410px]">
                <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3">
                  {`Spell-checked subtitles`}
                </h1>
                <p className="w-4 my-3 border-2"></p>
                <p className=" text-[18px] text-[#4f4f4f]  text-center sm:text-left mt-4 sm:mt-2 opacity-80">
                  {`60 minutes of subtitles & video transcriptions.`}{" "}
                  <span className="italic">
                    {" "}
                    Note: minutes reset monthly and do not roll over.{" "}
                  </span>
                </p>
              </div>
            </div>
            <div className="border m-2 my-4 md:min-w-[420px] md:max-w-[420px] p-8 bg-white  flex-wrap justify-evenly  items-center">
              <img
                src={require("../images/premiumMusic.png")}
                alt=""
                className="mx-auto h-44 w-44"
              />
              <div className="max-w-[410px]">
                <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3">
                  {`Premium music from Epidemic Sound`}
                </h1>
                <p className="w-4 my-3 border-2"></p>
                <p className=" text-[18px] text-[#4f4f4f]  text-center sm:text-left mt-4 sm:mt-2 opacity-80">
                  {`Access to a premier library of over 100,000 music soundtracks and sound effects.`}{" "}
                  <span className="italic">
                    {" "}
                    Pom plan only. Included free with Eskimo plan.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-8 border-red-600">
        <DatePicker />
      </div>
      <div className="bg-[#fff]">
        <img
          src={require("../images/mountain1.png")}
          alt=""
          className="w-[100vw] h-80 hidden lg:block"
        />
      </div>
      {/* <div className="bg-black">
        <TextCarasoulForPricing />
      </div> */}
      {/* <div className="bg-[#f4f8f9] pb-16 pt-10">
        <FAQs heading="FAQs" />
        <div className="pt-28 pb-10 max-w-[1320px] mx-auto px-5">
          <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#323a41] mt-3">
            Still have questions?
          </h1>
        </div>
        <div className="pb-10 -mt-4 text-center">
          <Link to="/category/case-studies">
            <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-gray-200 hover:bg-gray-300 transition duration-200 ease-out text-[#323a41] text-center mx-auto">
              Get your answers here
            </button>
          </Link>
        </div>
      </div> */}
      <Footer />
    </div>
  );
};

export default Pricing;
